import angular from 'angular';

import SpinnerComponent from './spinner.component';

const SpinnerModule = angular
    .module('control-room.commons.basic.components.spinner', [])
    .component('crSpinner', SpinnerComponent);

export default SpinnerModule;
